// extracted by mini-css-extract-plugin
module.exports = {"label":"SearchResults_label__137h-","marginTop":"SearchResults_marginTop__ZBxwW","link":"SearchResults_link__D2JBU"};